import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Optionally import the services that you want to use
// import {...} from "firebase/auth";
// import {...} from "firebase/database";
// import {...} from "firebase/firestore";
// import {...} from "firebase/functions";
// import {...} from "firebase/storage";

export const app = initializeApp({
	// apiKey: "AIzaSyAPBo99PSvUwaoVbC-riTuI-Zn53sL7KMs",
	// authDomain: "matemattici-test.firebaseapp.com",
	// projectId: "matemattici-test",
	// storageBucket: "matemattici-test.appspot.com",
	// messagingSenderId: "799625096612",
	// appId: "1:799625096612:web:126a45ab31f7028cd5a531",
	// measurementId: "G-5NZVGZKN27",
	apiKey: "AIzaSyBbi8V15Lz7sHb4_4GHQWy4U9ySHHyBwp8",
	authDomain: "matemattici-training.firebaseapp.com",
	projectId: "matemattici-training",
	storageBucket: "matemattici-training.appspot.com",
	messagingSenderId: "951688417196",
	appId: "1:951688417196:web:15999817ab4e3eb7467409",
});

export const db = getFirestore(app);

export const sessionData = {
	idToken: "",
};

export function getUserFullName() {
	const auth = getAuth(app);
	if (auth && auth.currentUser) {
		return auth.currentUser.displayName;
	}
	return "";
}

export function getUserPhotoUrl() {
	const auth = getAuth(app);
	if (auth && auth.currentUser) {
		return auth.currentUser.photoURL;
	}
	return "";
}

export function getUserId() {
	const auth = getAuth(app);
	if (auth && auth.currentUser) {
		return auth.currentUser.uid;
	}
	return "";
}
